import { QueryParametersState } from "@idw-types/state";

export enum QueryParametersActionTypes {
    SET_QUERY_PARAMETERS = "SET_QUERY_PARAMETERS"
}

type SetQueryParametersAction = {
    type: QueryParametersActionTypes.SET_QUERY_PARAMETERS;
    payload: { queryParameters: QueryParametersState };
};

export const setQueryParameters = (queryParameters: QueryParametersState): SetQueryParametersAction => ({
    type: QueryParametersActionTypes.SET_QUERY_PARAMETERS,
    payload: {
        queryParameters
    }
});

export type QueryParametersActions = SetQueryParametersAction;